import React, { useCallback, useEffect, useState } from "react";
import cn from "classnames";
import { createPortal } from "react-dom";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import styles from "./ModalProduct.module.sass";
import Icon from "../Icon";
import { getCurrentPartnerInfo } from "../../services/partner.service";

const ModalProduct = ({ visible, onClose, title, figcaption, gallery, isFirstConnexion = false }) => {
  const [internalRules, setInternalRules] = useState('');
  const [loading, setLoading] = useState(true);

  const escFunction = useCallback(
    (e) => {
      if (e.keyCode === 27 && !isFirstConnexion) {
        onClose();
      }
    },
    [onClose, isFirstConnexion]
  );

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);
    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);

  useEffect(() => {
    if (visible) {
      const target = document.querySelector("#modal-product");
      disableBodyScroll(target);
    } else {
      clearAllBodyScrollLocks();
    }
  }, [visible]);

  // Récupérer le règlement intérieur du partenaire
  useEffect(() => {
    const fetchPartnerRules = async () => {
      if (visible) {
        setLoading(true);
        try {
          const partnerInfo = await getCurrentPartnerInfo();
          if (partnerInfo && partnerInfo.internal_rules) {
            setInternalRules(partnerInfo.internal_rules);
          } else {
            // Règlement par défaut si aucun règlement personnalisé
            setInternalRules('<p>Aucun règlement intérieur personnalisé n\'a été défini pour ce partenaire.</p>');
          }
        } catch (error) {
          console.error('Erreur lors de la récupération du règlement intérieur:', error);
          setInternalRules('<p>Erreur lors du chargement du règlement intérieur.</p>');
        } finally {
          setLoading(false);
        }
      }
    };

    fetchPartnerRules();
  }, [visible]);

  return createPortal(
    visible && (
      <div id="modal-product" className={styles.modal} onClick={isFirstConnexion ? null : undefined}>
        <div className={styles.control}>
          <button className={styles.close} onClick={onClose}>
            <Icon name="close" size="20" />
          </button>
        </div>
        <div className={styles.outer}>
          <div className={styles.overview}>
            <div className={cn("title-red", styles.subtitle)}>Règlement intérieur</div>
            <div className={styles.content}>
              {loading ? (
                <p>Chargement du règlement intérieur...</p>
              ) : (
                <div dangerouslySetInnerHTML={{ __html: internalRules }} />
              )}
            </div>
          </div>
        </div>
      </div>
    ),
    document.body
  );
};

export default ModalProduct;